import { mapGetters, mapMutations, mapActions } from "vuex";
import { globalLoader } from '@/helpers/variables/index';
import {
    CHANGE_POPUP_LDAP,
} from '@/store/mutation-types';
import {
    SING_IN_WITH_LDAP,
    FETCH_USER_DATA
} from '@/store/action-types';

import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";


export default {
    name: 'auth-ldap',
    mixins: [validationMixin],
    data() {
        return {
            payload: {
                login: '',
                password: ''
            },
            validationErrors: {},
        }
    },
    validations: {
        payload: {
            login: {
                required,
            },
            password: {
                required,
            },
        }
    },
    computed: {
        ...mapGetters({
            config: 'setting/config',
            loading: 'auth/singInLdapLoading',
        }),
        disableButton(){
            if(
                this.payload.login === '' ||
                this.payload.password === ''
            ){
                return true
            }
            return false
        },
        loginErrors() {
            let error = [];
            if (!this.$v.payload.login.$dirty) {
                return error;
            }
            if (!this.$v.payload.login.required) {
                error.push(this.$t('validationRequired'))
            }
            if (this.validationErrors.login) {
                this.validationErrors.login.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        passwordErrors() {
            let error = [];
            if (!this.$v.payload.password.$dirty) {
                return error;
            }
            if (!this.$v.payload.password.required) {
                error.push(this.$t('validationRequired'));
            }
            if (this.validationErrors.password) {
                this.validationErrors.password.forEach((row) => {
                    error.push(row);
                })
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
            singIn: `auth/${SING_IN_WITH_LDAP}`,
            fetchUser: `profile/${FETCH_USER_DATA}`,
        }),
        ...mapMutations({
            changePopup: `auth/${CHANGE_POPUP_LDAP}`,
        }),
        resetForm(){
            this.payload.login = '';
            this.payload.password = '';
            this.$v.$reset();
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.singIn(this.payload).then(() => {
                    this.changePopup(false);
                    globalLoader(true);
                    this.fetchUser().then(() => {
                        globalLoader(false);
                        this.$router.push({name: 'orders'});
                        this.resetForm();
                    });
                }).catch(error => {
                    if (error.response.status === 418) {
                        this.$toasted.error(error.response.data.data.error.message).goAway(5000);
                    }
                })
            }
        }
    },
    destroyed(){

    }
}
